<div class="tabbar d-flex justify-content-between align-items-end">
  <div class="d-flex align-items-center">
    <button class="btn btn-filter mr-2" 
      [ngClass]="showingPage === Page.Summary ? 'folder-tab active' : 'folder-tab no-print'"
      (click)="switchTab(Page.Summary)">
      Summary
    </button>
    <button class="btn btn-filter mr-2" 
      [ngClass]="showingPage === Page.Weekly ? 'folder-tab active' : 'folder-tab no-print'"
      (click)="switchTab(Page.Weekly)">
      Weekly Report
    </button>
    <button class="btn btn-filter mr-2" *ngIf="isInternal"
      [ngClass]="showingPage === Page.EEU ? 'folder-tab active' : 'folder-tab no-print'"
      (click)="switchTab(Page.EEU)">
      EEU Report
    </button>
  </div>
  <!-- <div class="speaking-score-container">
    <div class="speaking-score-number">398</div>
    <div class="speaking-score-label">Speaking score</div>
    <div class="speaking-score-average">Class average</div>
  </div> -->
</div>

<div class="border px-4 py-2">
  <div *ngIf="report" class="row header my-4">
    <div class="col-md-3">
      <div class="detail-name">Class</div>
      <div class="detail-value">{{ report.OrganizationDescription }}</div>
    </div>
    <div class="col-md-3" *ngIf="report.TeacherName">
      <div class="detail-name">Teacher</div>
      <div class="detail-value"><a [routerLink]="'/accounts/' + report.TeacherID">{{ report.TeacherName }}</a></div>
    </div>
    <div class="col-md-3">
      <div class="detail-name">Start</div>
      <div class="detail-value">{{ report.StartingOn | date }}</div>
    </div>
    <div class="col-md-2">
      <div class="detail-name">Total Students</div>
      <div class="detail-value">{{ report.Students.length }}</div>
    </div>
    <div class="col-md-3" *ngIf="!report.TeacherName"></div>
    <div class="col-md-1">
      <div class="ml-auto mt-2 no-print">
        <a *ngIf="report" (click)="printPage()" ngbTooltip="Print">
          <i class="fal fa-print pointer"></i>
        </a>
      </div>
    </div>
  </div>
  
  <div *ngIf="showingPage === Page.Summary">
    <app-class-summary [classID]="classID" [organizationID]="organizationId" [report]="report"></app-class-summary>
  </div>
  
  <div *ngIf="showingPage === Page.Weekly">
    <app-class-weekly-report [classID]="classID" [organizationID]="organizationId" [teacherID]="report.TeacherID"></app-class-weekly-report>
  </div>
  <div *ngIf="showingPage === Page.EEU && isInternal">
    <app-class-eeu-report [classID]="classID" [organizationID]="organizationId"></app-class-eeu-report>
  </div>
</div>